import React from 'react';

export type KnowledgeTone = 'neutral' | 'signature' | 'success' | 'warning' | 'error' | 'info';

const TONE_CLASS: Record<KnowledgeTone, string> = {
  neutral: 'kb-tone-neutral',
  signature: 'kb-tone-signature',
  success: 'kb-tone-success',
  warning: 'kb-tone-warning',
  error: 'kb-tone-error',
  info: 'kb-tone-info',
};

export const KnowledgeStatus: React.FC<React.HTMLAttributes<HTMLSpanElement> & { tone?: KnowledgeTone }> = ({
  tone = 'neutral',
  className = '',
  children,
  ...props
}) => (
  <span className={`kb-status ${TONE_CLASS[tone]} ${className}`.trim()} {...props}>
    {children}
  </span>
);

export const KnowledgeSectionHeading: React.FC<{
  id?: string;
  title: string;
  description?: string;
  action?: React.ReactNode;
}> = ({ id, title, description, action }) => (
  <div className="kb-section-heading">
    <div>
      <h2 id={id} className="heading-4">{title}</h2>
      {description && <p>{description}</p>}
    </div>
    {action && <div className="kb-section-action">{action}</div>}
  </div>
);
